const ɵ0 = (moment) => {
    return (input) => {
        return moment(input).format("hh:mm a");
    };
};
const filter = ['moment', ɵ0];
export const FourDotFiveTimeFormatFilter = {
    name: 'fourdotfiveTimeFormat',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-time-format.filter.js.map